import { ActionRegistryCategory } from '../../../ActionRegistryCategory';
export class ActionsLearnwareAspect extends ActionRegistryCategory {
    label = 'Lazy';
    constructor(parent) {
        super(parent);
        super.init();
    }
}
